import { render, staticRenderFns } from "./BaseH6.vue?vue&type=template&id=aa4c0cda&"
import script from "./BaseH6.vue?vue&type=script&lang=js&"
export * from "./BaseH6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports